import { render, staticRenderFns } from "./ResultCourse.vue?vue&type=template&id=6190b23a"
import script from "./ResultCourse.vue?vue&type=script&lang=js"
export * from "./ResultCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports